import styles from "./ScrollBox.module.css";
import classNames from "classnames";

/**
 * Scrollable container with a styled scroll bar.
 */
export function ScrollBox({ children, className, ...props }) {
  return (
    <div {...props} className={classNames(styles.box, className)}>
      {children}
    </div>
  );
}
